import React from 'react'
import styles from "../../analytics.module.css"


const AutoSwitchModal = ({ setShowAutoSwitch, setAutoSwitchData, handleAutoSwitch, switchLoading, autoSwitchResult, autoSwitchData}) => {
    return (
        <div className={styles.modalOverlay} onClick={() => setShowAutoSwitch(false)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={() => setShowAutoSwitch(false)}>
                    ×
                </button>

                <h2>Auto Supplier Switch Analysis</h2>

                <div className={styles.formGroup}>
                    <label>Product ID</label>
                    <input
                        type="text"
                        value={autoSwitchData.productId}
                        onChange={(e) => setAutoSwitchData({ ...autoSwitchData, productId: e.target.value })}
                        placeholder="e.g., MLBB_DIAMONDS_100"
                    />
                </div>

                <div className={styles.formGroup}>
                    <label>Current Supplier</label>
                    <input
                        type="text"
                        value={autoSwitchData.currentSupplier}
                        onChange={(e) => setAutoSwitchData({ ...autoSwitchData, currentSupplier: e.target.value })}
                        placeholder="e.g., yokcash"
                    />
                </div>

                <div className={styles.formGroup}>
                    <label>Reason</label>
                    <input
                        type="text"
                        value={autoSwitchData.reason}
                        onChange={(e) => setAutoSwitchData({ ...autoSwitchData, reason: e.target.value })}
                        placeholder="e.g., High failure rate detected"
                    />
                </div>

                <button
                    onClick={handleAutoSwitch}
                    disabled={switchLoading || !autoSwitchData.productId || !autoSwitchData.currentSupplier}
                    className={styles.primaryButton}
                >
                    {switchLoading ? "Analyzing..." : "Analyze Switch"}
                </button>

                {autoSwitchResult && (
                    <div className={styles.switchResult}>
                        <h3>Switch Recommendation</h3>
                        <div className={styles.switchDecision}>
                            <strong>Should Switch:</strong> {autoSwitchResult.shouldSwitch ? "✓ Yes" : "✗ No"}
                        </div>

                        {autoSwitchResult.recommendation && (
                            <>
                                <div className={styles.switchInfo}>
                                    <p>
                                        <strong>From:</strong> {autoSwitchResult.recommendation.fromSupplier}
                                    </p>
                                    <p>
                                        <strong>To:</strong> {autoSwitchResult.recommendation.toSupplier}
                                    </p>
                                    <p>
                                        <strong>Reason:</strong> {autoSwitchResult.recommendation.reason}
                                    </p>
                                </div>

                                <div className={styles.performanceComparison}>
                                    <div>
                                        <h4>Current Performance</h4>
                                        <p>Failure Rate: {autoSwitchResult.recommendation.currentPerformance?.failureRate}%</p>
                                        <p>Avg Cost: ₹{autoSwitchResult.recommendation.currentPerformance?.avgCost}</p>
                                        <p>Recent Orders: {autoSwitchResult.recommendation.currentPerformance?.recentOrders}</p>
                                    </div>

                                    <div>
                                        <h4>Recommended Performance</h4>
                                        <p>Success Rate: {autoSwitchResult.recommendation.recommendedPerformance?.successRate}%</p>
                                        <p>Avg Cost: ₹{autoSwitchResult.recommendation.recommendedPerformance?.avgCost}</p>
                                        <p>Recent Orders: {autoSwitchResult.recommendation.recommendedPerformance?.recentOrders}</p>
                                    </div>
                                </div>

                                {autoSwitchResult.recommendation.estimatedImprovement && (
                                    <div className={styles.improvement}>
                                        <h4>Estimated Improvement</h4>
                                        <p>
                                            Success Rate Gain: +{autoSwitchResult.recommendation.estimatedImprovement.successRateGain}%
                                        </p>
                                        <p>Cost Change: {autoSwitchResult.recommendation.estimatedImprovement.costChange}%</p>
                                    </div>
                                )}
                            </>
                        )}

                        {autoSwitchResult.alternatives && autoSwitchResult.alternatives.length > 0 && (
                            <div className={styles.alternatives}>
                                <h4>Alternative Suppliers</h4>
                                <ul>
                                    {autoSwitchResult.alternatives.map((alt, index) => (
                                        <li key={index}>
                                            {alt.supplier} - Success Rate: {alt.successRate}%
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default AutoSwitchModal